import { type FC, memo } from 'react';

import { useTranslation } from '@crehana/i18n';
import { clsx } from 'clsx';

import type { FormSubmitProps } from './types';

const FormSubmit: FC<FormSubmitProps> = ({
  children,
  onSubmit,
  onOpenDialog,
  isValid,
  labelSubmit,
  labelCancel,
  withRequiredFields,
  className,
}) => {
  const { t } = useTranslation();

  const handleSubmit = () => {
    if (onSubmit) {
      const result = onSubmit();
      if (result && result.then) {
        result.then(() => onOpenDialog());
      }
    }
  };

  const handleCancel = () => {
    onOpenDialog(true);
  };

  return (
    <div className={clsx('tw-flex tw-flex-1 tw-flex-wrap', className)}>
      <div
        className={clsx(
          'tw-flex tw-flex-1',
          withRequiredFields && 'tw-mb-1 sm:tw-mb-0',
        )}
      >
        {withRequiredFields && (
          <p className="tw-flex tw-self-center tw-text-12 tw-font-body5 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500">
            {t('GLOBAL_REQUIRED_FIELDS')}
          </p>
        )}
      </div>
      <div className="tw-flex tw-w-full sm:tw-w-auto">
        <div className="tw-flex tw-justify-end sm:tw-justify-end ">
          {/* TODO: talk with the code owner to fix this code so we can enable this rule again */}
          {/* eslint-disable-next-line react/button-has-type */}
          {/* biome-ignore lint/a11y/useButtonType: button type handled elsewhere */}
          <button
            className="tw-flex tw-btn-tertiary-xs sm:tw-btn-tertiary-s md:tw-btn-tertiary-m"
            onClick={handleCancel}
          >
            {labelCancel || t('GLOBAL_CANCEL')}
          </button>
        </div>
        {/* TODO: talk with the code owner to fix this code so we can enable this rule again */}
        {/* eslint-disable-next-line react/button-has-type */}
        {/* biome-ignore lint/a11y/useButtonType: button type handled elsewhere */}
        <button
          className={clsx(
            'tw-flex tw-flex-1 tw-btn-primary-xs sm:tw-btn-primary-s md:tw-btn-primary-m',
            !isValid && 'tw-btn-disabled',
          )}
          onClick={handleSubmit}
        >
          <p className="tw-m-auto">{labelSubmit}</p>
        </button>
      </div>
      {children}
    </div>
  );
};

export default memo(FormSubmit);
